import React, { useEffect, useState } from "react";

import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import AboutBreadcrumb from "../../components/AboutPage/AboutBreadcrumb/AboutBreadcrumb";

import "./Projects.css";
import projectsData from "../../data/projectsData";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const filters = [
  { label: "All Projects", value: "all" },
  { label: "Oil and Gas", value: "Gas" },
  { label: "Pre-Engineered Building", value: "Building" },
  { label: "Real Estate", value: "Estate" },
];

const Projects = () => {
  const [activeFilter, setActiveFilter] = useState("all");
  const [selectedProject, setSelectedProject] = useState(null);

  const filteredProjects =
    activeFilter === "all"
      ? projectsData
      : projectsData.filter((item) => item.category === activeFilter);

  const closeModal = () => {
    setSelectedProject(null);
  };

  useEffect(() => {
    if (!selectedProject) return;

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        closeModal();
      }
    };

    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", handleKeyDown);

    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [selectedProject]);

  return (
    <>
      <Header />

      <AboutBreadcrumb label="Projects" />

      <section className="project-filters">
        <ul>
          {filters.map((filter) => (
            <li
              key={filter.value}
              className={activeFilter === filter.value ? "active" : ""}
              onClick={() => setActiveFilter(filter.value)}
            >
              {filter.label}
            </li>
          ))}
        </ul>
      </section>

      <section className="projects-grid">
        {filteredProjects.map((project) => (
          <article
            key={project.id}
            className="project-card"
            onClick={() => setSelectedProject(project)}
            tabIndex="0"
            onKeyDown={(event) => {
              if (event.key === "Enter") {
                setSelectedProject(project);
              }
            }}
          >
            <img src={project.images[0]} alt={project.title} />

            <div className="project-info">
              <span>{project.location}</span>
              <h3>{project.title}</h3>
            </div>
          </article>
        ))}
      </section>

      {selectedProject && (
        <div className="project-modal-backdrop" onClick={closeModal}>
          <div
            className="project-modal"
            role="dialog"
            aria-modal="true"
            aria-labelledby="project-modal-title"
            onClick={(event) => event.stopPropagation()}
          >
            <button
              className="project-modal-close"
              onClick={closeModal}
              aria-label="Close project popup"
            >
              ×
            </button>

            {/* Swiper Slider */}
            <div className="project-modal-media">
              <Swiper
                modules={[Navigation, Pagination, Autoplay]}
                navigation
                pagination={{ clickable: true }}
                autoplay={{
                  delay: 3000,
                  disableOnInteraction: false,
                }}
                loop={true}
                className="project-swiper"
              >
                {selectedProject.images.map((image, index) => (
                  <SwiperSlide key={index}>
                    <img
                      src={image}
                      alt={`${selectedProject.title} ${index + 1}`}
                      className="project-modal-image"
                    />
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>

            <div className="project-modal-content">
              <span className="project-modal-location">
                {selectedProject.location}
              </span>

              <h3 id="project-modal-title">{selectedProject.title}</h3>

              <p>{selectedProject.description}</p>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </>
  );
};

export default Projects;